/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject } from '@angular/core';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { CDS_POPUP_DATA, MatDialogRef, CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { TitleCasePipe } from '@angular/common';
import { CdsLanguageModule } from '@cds/ng-core/lang';
@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss'],
  imports: [CdsPopupModule, CdsButtonModule, TitleCasePipe, CdsLanguageModule],
})
export class AlertPopupComponent {
  private dialogRef = inject<MatDialogRef<AlertPopupComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    message: string;
    buttonName: string;
    params: any;
  }>(CDS_POPUP_DATA);

  disagreeButtonConfig: CdsButtonConfig = { size: 'sm', style: 'secondary' };
  agreeButtonConfig: CdsButtonConfig = { size: 'sm' };

  constructor() {
    const data = this.data;

    if (data.params) this.params = data.params;
  }
  params = {};

  close() {
    this.dialogRef.close({ agree: true });
  }
}
